import Language from '@/common/models/misc-api-models/Language';
import i18n from '@/vueI18n';

import UnitRatioStatuses, { IUnitRatioStatusesAPI } from './UnitRatioStatuses';

export interface ILanguageUnitRatioStatusesAPI {
  language_ids: number[];
  language_codes: string[];
  language_names: string[];
  ratio_statuses: IUnitRatioStatusesAPI;
}

export default class LanguageUnitRatioStatuses {
  languages: Language[];

  unitRatioStatuses: UnitRatioStatuses;

  lineItemID: string | null;

  constructor(languages: Language[], unitRatioStatuses: UnitRatioStatuses, lineItemID: string | null = null) {
    this.languages = languages;
    this.unitRatioStatuses = unitRatioStatuses;
    this.lineItemID = lineItemID;
  }

  get languageCodes(): string {
    return this.languages.length === 0
      ? i18n.global.t('messages.noSpecificLanguage')
      : this.languages.map((x) => x.code).join(', ');
  }

  get languageNames(): string {
    return this.languages.length === 0
      ? i18n.global.t('messages.noSpecificLanguage')
      : this.languages.map((x) => x.name).join(', ');
  }

  get unitCount(): number {
    return this.unitRatioStatuses.all.reduce((mem, x) => mem + x.unitCount, 0);
  }

  get unitCoveredCount(): number {
    return this.unitRatioStatuses.all.reduce((mem, x) => mem + x.unitCoveredCount, 0);
  }

  static fromApi(apiObject: ILanguageUnitRatioStatusesAPI): LanguageUnitRatioStatuses {
    const languages: Language[] = apiObject.language_ids.map(
      (id: number, i: number) => new Language(id, apiObject.language_codes[i], apiObject.language_names[i]),
    );
    return new LanguageUnitRatioStatuses(languages, UnitRatioStatuses.fromApi(apiObject.ratio_statuses));
  }

  toApi(): ILanguageUnitRatioStatusesAPI {
    const languageIds: number[] = [];
    const languageCodes: string[] = [];
    const languageNames: string[] = [];
    this.languages?.forEach((language) => {
      languageIds.push(language.id);
      languageCodes.push(language.code);
      languageNames.push(language.name);
    });
    return {
      language_ids: languageIds,
      language_codes: languageCodes,
      language_names: languageNames,
      ratio_statuses: this.unitRatioStatuses?.toApi(),
    };
  }
}
